export enum OfflineRechargeSteps {
    READ = 1,
    PAY_RECHARGE,
    RECORD
}